Lesson (stxt.play.tutorial): Welcome!
	Progress: 1/5
	Explanation >>
		**Welcome to the STXT Playground!**

		This is a tutorial for learning STXT.
		Here you can play and try the language.

		When you've finished a lesson,
		you can delete the document... or not ;-)

		You can always reset the workspace
		to the defaults (button ↺).

		Let's start! **What is STXT**.
